import { Button, Modal, Text } from '@fozito/common-ui';
import { get } from 'lodash';
import styled from 'styled-components';
import { PAYMENT_TYPE } from '../../cashier.constants';
import ebt_cash_icon from './ebt-cash.svg';
import ebt_food_icon from './ebt-food.svg';

const TitleStyled = styled.div`
display: flex;
padding: 24px 24px 32px 24px;
flex-direction: column;
justify-content: center;
align-items: center;
gap: 16px;
align-self: stretch;
`;
const FormStyled = styled.div`
  display: flex;
  padding: 16px 16px 40px 16px;
  justify-content: center;
  align-items: center;
  gap: 16px;
  align-self: stretch;
`;
type Props = {
  open?: boolean;
  onClose?: () => void;
  onPaymentWith: (type: string) => void;
};

const ModalChooseType = (({ open, onClose, onPaymentWith }: Props) => {
  const _onChooseType = (type: string) => () => onPaymentWith(type);
  return (
    <Modal title='' open={open} onClose={onClose} width={900} styles={{ header: { display: 'none' }, body: { display: 'flex', flexDirection: 'column', padding: 16 } }}>
      <TitleStyled><Text title_h5_24_semibold_caplock text_center color_text_5>Choose EBT Type</Text></TitleStyled>
      <FormStyled>
        <ButtonEBT type={PAYMENT_TYPE.EBT_FOOD} onClick={_onChooseType(PAYMENT_TYPE.EBT_FOOD)} />
        <ButtonEBT disabled type={PAYMENT_TYPE.EBT_CASH} onClick={_onChooseType(PAYMENT_TYPE.EBT_CASH)} />
      </FormStyled>
      <Button style={{ alignSelf: 'stretch' }} block onClick={onClose} type_cancel><span>Close</span></Button>
    </Modal>
  );
});
export default ModalChooseType;

const configs = {
  [PAYMENT_TYPE.EBT_FOOD]: {
    icon: ebt_food_icon,
    label: 'EBT FOOD',
  },
  [PAYMENT_TYPE.EBT_CASH]: {
    icon: ebt_cash_icon,
    label: 'EBT CASH',
  },
};
const ButtonEBTContainer = styled.button`
  display: flex;
  width: 264px;
  height: 221px;
  padding: 16px 24px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 4px;
  border-radius: 4px;
  border: 1px solid #CCD4DC;
  background: #FFF;
  box-shadow: 0px 2px 4px 0px rgba(44, 35, 66, 0.40), 0px 4px 8px -3px rgba(45, 35, 66, 0.30), 0px -3px 0px 0px #D6D6E7 inset;
  img.icon {
    height: 80px;
    width: auto;
  }
  &:hover,
  &:active {
    opacity: 0.8;
    transform: scale(1.05);
    transition: all 0.1s;
  }

  &:disabled {
    opacity: 0.7;
    &:hover,
    &:active {
      opacity: 0.7;
      cursor: not-allowed;
      transform: none;
      transition: none;
    }
  }
`;
type ButtonEBTProps = {
  type: string;
  disabled?: boolean;
  onClick: () => void;
};
const ButtonEBT = ({ type, disabled, onClick }: ButtonEBTProps) => {
  const config = get(configs, type);
  if (!config) return null;

  return (
    <ButtonEBTContainer type='button' onClick={onClick} disabled={disabled}>
      <img src={config.icon} alt={config.label} className="icon" />
      <Text title_h7_20_semibold text_center color_text_5>{config.label}</Text>
    </ButtonEBTContainer>
  );
};
